<div class="text-input-container {{styling}} {{getContainerClass()}}">

  <div class="text-input-icon {{icon}}" *ngIf="icon" [ngClass]="getIconClass()"></div>
  <input class="text-input-field"
    #inputControl
    placeholder="{{placeholder}}"
    type="{{type}}"
    maxlength = "{{maxLength}}"
    [formControl]="inputFormControl"
    (focus)="onFocus(true)"
    (blur)="onFocus(false)"
    (keyup.enter)="onEnter($event)"
    [attr.disabled]="isDisabled?'':null"
    autocomplete="{{autocomplete}}" [(value)]="value"/>
</div>

<div class="text-input-error-message" *ngIf="hasErrorText()">{{errorMessage}}</div>
